import React from 'react';
import DefaultApp from "./DefaultApp";
import {Tab, Tabs} from '@material-ui/core';
import {Redirect, Route, Switch, withRouter} from "react-router-dom";
import CrackListExpansionAppDataVersions from "./crack-list-exp/CrackListExpansionAppDataVersions";
import CrackListExpansionLists from "./crack-list-exp/CrackListExpansionLists";
import CrackListExpansionListDetails from "./crack-list-exp/CrackListExpansionListDetails";

class CrackListExpansion extends DefaultApp {

    render () {
        const { app, match } = this.props;
        return (
            <div>
                <Switch>
                    <Route path={`${match.url}/create-list/:languageId/`} render={(props) => (
                        <CrackListExpansionListDetails app={app} />
                    )} />
                    <Route path={`${match.url}/list/:listId/`} render={(props) => (
                        <CrackListExpansionListDetails app={app} />
                    )} />
                    <Route path={`${match.path}/:tab`}>
                        <CrackListExpansionTabs app={app}/>
                    </Route>
                    <Route render={() => <Redirect to={`/${app.url_slug}/${CrackListExpansionTabs.defaultTab}/`}/>} />
                </Switch>


            </div>
        );
    }
}

class CrackListExpansionTabs extends React.Component {

    static defaultTab = "lists";

    constructor(props) {
        super(props);
        this.state = {
            currentTab: CrackListExpansionTabs.getCurrentTab(props),
        };
    }

    static getCurrentTab(props) {
        const tabName = props.match.params.tab;
        return tabName === undefined ? CrackListExpansionTabs.defaultTab : tabName;
    }

    static getDerivedStateFromProps(props, state) {
        return {
            ...state,
            currentTab: CrackListExpansionTabs.getCurrentTab(props),
        };
    }

    onCurrentTabChange = (e, value) => {
        this.props.history.push('/'+this.props.app.url_slug + '/' + value);
    };

    render() {
        const { app } = this.props;
        return (
            <React.Fragment>
                <Tabs
                    value={this.state.currentTab}
                    onChange={this.onCurrentTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                    style={{
                        margin: '-20px -22px 22px -22px',
                        borderBottom: '1px #ddd solid',
                        background: 'white',
                    }}
                    scrollable="true"
                    scrollButtons="auto"
                >
                    <Tab
                        value="lists"
                        label="Listes"
                    />
                    <Tab
                        value="publish"
                        label="Publication"
                    />
                </Tabs>

                <Switch>
                    <Route path={`/${app.url_slug}/lists/`} render={(props) => (
                        <CrackListExpansionLists app={app}/>
                    )} />
                    <Route exact path={`/${app.url_slug}/publish/`} render={(props) => (
                        <CrackListExpansionAppDataVersions app={app}/>
                    )} />
                    <Route/>
                </Switch>
            </React.Fragment>
        );
    }
}

CrackListExpansionTabs = withRouter(CrackListExpansionTabs);

export default withRouter(CrackListExpansion);
